import useSettingsSpeciesEditRoute_Delete from "../api/useSettingsSpeciesEditRoute_Delete";
import useSettingsSpeciesEditRoute_GetById from "../api/useSettingsSpeciesEditRoute_GetById";
import useSettingsSpeciesEditRoute_Update from "../api/useSettingsSpeciesEditRoute_Update";

export function useSettingsSpeciesData(speciesId: string) {
    const queryData = useSettingsSpeciesEditRoute_GetById(speciesId);
    const updateMutation = useSettingsSpeciesEditRoute_Update();
    const deleteMutation = useSettingsSpeciesEditRoute_Delete();

    return {
        queryData,
        updateMutation,
        deleteMutation,
    };
}
